import type { IconNode } from '../types';

/**
 * @name gem-ring
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMuMiA4LjEgMTYgNC40IDE0LjQgMkg5LjZMOCA0LjRsMi44IDMuNyIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjE1IiByPSI3IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/gem-ring
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const gemRing: IconNode = [
  ['path', { d: 'M13.2 8.1 16 4.4 14.4 2H9.6L8 4.4l2.8 3.7', key: 'srrhiz' }],
  ['circle', { cx: '12', cy: '15', r: '7', key: '14w87o' }],
];

export default gemRing;
